import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/shipin2/icon-search.png';
const _withScopeId = n => (_pushScopeId("data-v-5fbe7e2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-nav"
};
const _hoisted_2 = {
  class: "search-input"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "left-icon",
  src: _imports_0
}, null, -1));
const _hoisted_4 = {
  class: "quick-links"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iai"
}, "历史", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iai"
}, "保存", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iai"
}, "客服", -1));
const _hoisted_8 = {
  key: 0,
  class: "pop-div"
};
const _hoisted_9 = {
  class: "notice-panel"
};
const _hoisted_10 = {
  class: "notice-panel__header"
};
const _hoisted_11 = {
  class: "notice-panel__title"
};
const _hoisted_12 = {
  class: "notice-panel__date"
};
const _hoisted_13 = {
  class: "notice-panel__qr notice-panel__icon"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "notice-panel__card-body"
};
const _hoisted_16 = {
  class: "notice-panel__card-title"
};
const _hoisted_17 = {
  class: "sp"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "notice-panel__card-desc"
}, " 建议立即收藏，避免失联 ", -1));
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "notice-panel__card-body"
};
const _hoisted_21 = {
  class: "notice-panel__card-title"
};
const _hoisted_22 = {
  key: 0,
  class: "notice-panel__badge"
};
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = {
  class: "notice-panel__footer"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "如有疑问请随时联系客服，祝您观影愉快～", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系客服", -1));
const _hoisted_27 = {
  key: 0,
  class: "iosdiv"
};
import { store } from "../utils/store.js";
import { ref, getCurrentInstance, onMounted, inject, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import QrcodeVue from 'qrcode.vue';
import html2canvas from 'html2canvas';
import { judgeClient, downloadApp } from '@/utils';
import dayjs from 'dayjs';
import { showToast } from 'vant';

// 根据渠道码判断是否显示保存网址
// import { store } from '../utils/store.js';
import { channelCode } from '@/js/channel';
import { X } from '../utils/request';
import HistoryIcon from "./icons/HistoryIcon.vue";
import SaveUrlIcon from "./icons/SaveUrlIcon.vue";
export default {
  __name: 'HeaderNav',
  props: {
    list: {}
  },
  emits: ["search"],
  setup(__props, {
    emit
  }) {
    const hasqudao = store.filterQudaolist.includes(X.Xchanne || channelCode);

    // 延迟2s获取下载地址这些吧值，因store.pinia
    const config = ref(store.config);
    setTimeout(() => {
      console.log('store', store.config);
      config.value = store.config;
    }, 2000);
    const isDev = getCurrentInstance()?.appContext.config.globalProperties.$isDev;
    const jump = url => {
      window.location.href = url;
    };
    const route = useRoute();
    const router = useRouter();
    const value = ref("");
    value.value = route.query.keyword;
    const activeChannel = computed(() => {
      const raw = store.config && store.config.channelCode || X.Xchanne || channelCode || '';
      return String(raw).toUpperCase();
    });
    const allowCustomerService = computed(() => activeChannel.value !== 'MANF' && activeChannel.value !== 'haijiao-17');
    const showCustomerServiceButton = computed(() => allowCustomerService.value && route.path !== '/customer-service');
    const goHistory = () => {
      router.push('/history');
    };
    const search = () => {
      if (!value.value) {
        return alert("请输入关键词");
      }
      if (route.query.keyword) {
        emit("search", value.value);
      } else {
        router.push({
          path: "more",
          query: {
            keyword: value.value
          }
        });
      }
    };
    const backHome = () => {
      router.push('/');
    };
    const show = ref(false);
    const saveTheUrl = () => {
      show.value = true;
    };
    const openSaveTheUrl = inject('openSaveTheUrl', () => {});
    openSaveTheUrl.value = saveTheUrl;
    const qrurl = ref('');
    const download = async imgUrl => {
      qrurl.value = await imgUrl;
      setTimeout(() => {
        html2canvas(document.querySelector('#dwqrcode')).then(canvas => {
          const link = document.createElement('a');
          link.download = 'qrcode.png';
          link.href = canvas.toDataURL();
          link.click();
        });
      }, 1000);
    };
    const query = item => {
      router.push({
        path: "more",
        query: {
          keyword: item,
          from: 'search'
        }
      });
    };
    const searchKeys = ["自慰", "极品", "学生", "人妻", "巨乳", "内射", "少女", "高潮", "女神", "少妇", "黑丝", "姐姐", "萝莉", "诱惑", "调教", "颜值", "中出", "美女", "乱伦", "清纯", "口交", "肛交", "口爆", "颜射", "吞精", "尿尿", "捆绑", "内射", "潮吹", "深喉", "偷窥", "自慰", "强奸", "车震", "教室", "大学", "part", "厕所", "酒店", "野外", "club", "商场", "飞机", "浴室", "按摩", "护士", "学生", "老师", "继母", "姐弟", "父女", "情侣", "房东", "邻居", "明星", "麻豆", "SWAG", "萝莉社", "JVID", "星空", "天美"];
    const keys = ref(searchKeys[Math.floor(Math.random() * searchKeys.length)]);
    const siteName = computed(() => store.config.logo_title || '站点');
    const today = computed(() => dayjs().format('YYYY-MM-DD'));
    const sanitizedDomain = computed(() => {
      const domain = store.config.website || store.config.share_url || '';
      return domain ? domain.replace(/^https?:\/\//, '') : '';
    });
    const primaryUrl = computed(() => store.config.website || store.config.share_url || '');
    const noticeHighlights = computed(() => {
      const email = store.config.email || '暂无邮箱';
      return [{
        id: 'email',
        title: '获取最新地址',
        desc: `发送任意邮件至 <strong>${email}</strong> 即可自动回复`,
        badge: '推荐',
        initial: '邮'
      }, {
        id: 'browser',
        title: '访问建议',
        desc: '强烈推荐使用 <strong>谷歌浏览器</strong>，体验更顺畅',
        initial: '荐'
      }, {
        id: 'network',
        title: '无法访问？',
        desc: '如遇联通无法打开，建议更换 <strong>移动/电信</strong> 网络或尝试科学上网',
        initial: '网'
      }];
    });
    onMounted(() => {});
    console.log('config.vue', config.value);
    const fallbackCopy = text => {
      if (typeof document === 'undefined') {
        return false;
      }
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      let succeeded = false;
      try {
        succeeded = document.execCommand('copy');
      } catch (error) {
        succeeded = false;
      }
      document.body.removeChild(textarea);
      return succeeded;
    };
    const copyToClipboard = async (text, successMessage) => {
      const value = (text || '').trim();
      if (!value) {
        showToast('暂无可复制地址');
        return;
      }
      if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(value);
          showToast(successMessage);
          return;
        } catch (error) {
          // ignore and use fallback
        }
      }
      if (fallbackCopy(value)) {
        showToast(successMessage);
      } else {
        showToast('复制失败，请手动复制');
      }
    };
    const copyLatestUrl = () => {
      const url = primaryUrl.value || sanitizedDomain.value;
      copyToClipboard(url, '已复制最新地址链接');
    };
    const handleNoticeCardClick = id => {
      if (id !== 'email') {
        return;
      }
      copyToClipboard(store.config.email, '已复制最新邮箱地址');
    };

    // 判断当前是安卓还是IOS，取渠道后台配置的 下载地址
    const clickDownApp = () => {
      let android_download_urls = [...config.value.android_download_urls.split(',')];
      let ios_download_urls = [...config.value.ios_download_urls.split(',')];
      console.log('android_download_urls', android_download_urls, 'ios_download_urls', ios_download_urls);
      downloadApp(ios_download_urls, android_download_urls);
    };
    const clickgotoIOSBookmark = () => {
      window.location.href = config.value.bookmark_url || config.value.ios_download_urls;
    };
    const goCustomerService = () => {
      router.push('/customer-service');
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_search = _resolveComponent("van-search");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_image, {
        class: "img",
        fit: "fill",
        src: _unref(store).isDev() ? require('@/assets/logo.png') : _unref(store).config.h5_logo,
        onClick: backHome
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_van_search, {
        placeholder: "大家都在搜...",
        onSearch: search,
        readonly: "",
        onClickInput: _cache[0] || (_cache[0] = $event => _ctx.$router.push('search'))
      }, {
        "left-icon": _withCtx(() => [_hoisted_3]),
        _: 1
      }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "history-link",
        onClick: goHistory
      }, [_createVNode(HistoryIcon), _hoisted_5]), !_unref(hasqudao) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "save-the-url",
        onClick: saveTheUrl
      }, [_createVNode(SaveUrlIcon), _hoisted_6])) : _createCommentVNode("", true), !_unref(hasqudao) && showCustomerServiceButton.value ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "save-the-url",
        onClick: goCustomerService
      }, [_createVNode(_component_van_icon, {
        name: "service",
        size: "1em"
      }), _hoisted_7])) : _createCommentVNode("", true)])]), _createVNode(_component_van_popup, {
        teleport: "#app",
        class: "pop-notice",
        show: show.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => show.value = $event),
        round: "",
        "close-on-click-overlay": false,
        style: {
          width: '90%',
          'background': 'none'
        }
      }, {
        default: _withCtx(() => [_createVNode(_Transition, {
          name: "animate__animated animate__zoomOut",
          "enter-active-class": "animate__zoomIn",
          "leave-active-class": "animate__zoomOut"
        }, {
          default: _withCtx(() => [show.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("button", {
            class: "notice-panel__close",
            type: "button",
            onClick: _cache[1] || (_cache[1] = $event => show.value = false)
          }, [_createVNode(_component_van_icon, {
            name: "cross"
          })]), _createElementVNode("div", _hoisted_9, [_createElementVNode("header", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(siteName.value) + " 今日公告", 1), _createElementVNode("div", _hoisted_12, _toDisplayString(today.value), 1)]), _createElementVNode("section", {
            class: "notice-panel__card notice-panel__card--qr is-clickable",
            onClick: copyLatestUrl
          }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
            style: {
              "width": "50px",
              "height": "50px",
              "border-radius": "8px"
            },
            src: _unref(store).config.favicon_ico,
            alt: "二维码"
          }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", _hoisted_16, [_createTextVNode("最新官网地址："), _createElementVNode("span", _hoisted_17, _toDisplayString(sanitizedDomain.value || '配置更新中'), 1)]), _hoisted_18])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeHighlights.value, item => {
            return _openBlock(), _createElementBlock("section", {
              key: item.id,
              class: _normalizeClass(['notice-panel__card notice-panel__card--info', {
                'is-clickable': item.id === 'email'
              }]),
              onClick: $event => handleNoticeCardClick(item.id)
            }, [_createElementVNode("div", {
              class: _normalizeClass(["notice-panel__icon", `is-${item.id}`])
            }, [_createElementVNode("span", null, _toDisplayString(item.initial), 1)], 2), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, [_createTextVNode(_toDisplayString(item.title) + " ", 1), item.badge ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(item.badge), 1)) : _createCommentVNode("", true)]), _createElementVNode("p", {
              class: "notice-panel__card-desc",
              innerHTML: item.desc
            }, null, 8, _hoisted_23)])], 10, _hoisted_19);
          }), 128)), _createElementVNode("footer", _hoisted_24, [_hoisted_25, allowCustomerService.value ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "notice-panel__service-btn",
            type: "button",
            onClick: goCustomerService
          }, [_createVNode(_component_van_icon, {
            name: "service",
            size: "16"
          }), _hoisted_26])) : _createCommentVNode("", true)])]), _unref(judgeClient)() === 'IOS' ? (_openBlock(), _createElementBlock("div", _hoisted_27)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"])]);
    };
  }
};